import React from 'react';
import { Box } from '@mui/material';
import NkySpinner from './NkySpinner/NkySpinner';

/**
 * Full-screen or contained loading scrim with branded spinner.
 * @param {boolean} [contained=false] Absolute within parent instead of fixed viewport
 */
const LoadingOverlay = ({ contained = false }) => (
  <Box
    role="presentation"
    sx={{
      position: contained ? 'absolute' : 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(26, 26, 46, 0.45)',
      backdropFilter: 'blur(3px)',
      zIndex: 9999,
    }}
  >
    <NkySpinner size="lg" onDark label="Loading" />
  </Box>
);

export default LoadingOverlay;
